import { RequestEvent } from 'state-data';

export class PasswordUpdatedEvent extends RequestEvent {}
